export const BillingRequestStatus = {
    Draft: 'draft',
    InProgress: 'in_progress',
    Requested: 'requested',
    Rejected: 'rejected',
    Declined: 'declined',
    Accepted: 'accepted',
    Pending: 'pending',
    Paid: 'paid',
};
//# sourceMappingURL=BillingRequestStatus.js.map